export default __webpack_public_path__ + "textEditorExtended.20550ca489569a053a556e956f994b07.png";